var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGoogleIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 25 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#4285F4",
  fillRule: "evenodd",
  d: "M24.02 12.275c0-.851-.076-1.67-.218-2.455H12.5v4.642h6.458a5.52 5.52 0 0 1-2.394 3.622v3.01h3.878c2.269-2.088 3.578-5.165 3.578-8.82",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#34A853",
  fillRule: "evenodd",
  d: "M12.5 24.001c3.24 0 5.956-1.074 7.942-2.907l-3.878-3.01c-1.075.72-2.45 1.145-4.064 1.145-3.125 0-5.77-2.111-6.715-4.948H1.776v3.11A12 12 0 0 0 12.5 24",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FBBC05",
  fillRule: "evenodd",
  d: "M5.785 14.279a7.2 7.2 0 0 1-.376-2.28c0-.791.136-1.56.376-2.28v-3.11H1.776A12 12 0 0 0 .5 12c0 1.936.464 3.769 1.276 5.389z",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#EA4335",
  fillRule: "evenodd",
  d: "M12.5 4.773c1.762 0 3.344.605 4.587 1.794l3.442-3.442C18.451 1.19 15.735 0 12.5 0 7.81 0 3.75 2.69 1.776 6.61l4.01 3.11c.943-2.836 3.589-4.947 6.714-4.947",
  clipRule: "evenodd"
})));
export default SvgGoogleIcon;